import { Modal, Typography, Button, notification } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import { actions } from "../slice";
import { actions as orderListActions } from "../../OrderListing/slice";
import { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";

const { Text } = Typography;

const ORDER_STATUS = {
  //   RECEIVED_AT_LAB: "receivedAtLab",
  UNDER_TESTING: "underTesting",
  //   REPORT_UPLOADED: "reportUploaded",
  //   REJECTED_BY_LAB: "rejectedByLab",
};

function LabellingFormSuccessModal({
  open,
  setOpen,
  id,
  getOrderStatusId,
  orderDetails,
}) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const orderStatusValue = orderDetails?.status?.value;

  const handleOk = () => {
    setIsLoading(true);
    dispatch(
      actions.moveToUnderTesting({
        orderId: orderDetails.orderId,
        statusId: getOrderStatusId(ORDER_STATUS.UNDER_TESTING),
        onSuccess: () => {
          notification.success({
            message: "Order got updated to Under Testing successfully!",
          });
          dispatch(orderListActions.setActiveNavOption("UNDER TESTING"));
          history.goBack();
          setOpen(false);
          setIsLoading(false);
        },
        onFailure: (error) => {
          notification.error({
            message: "Error Updating Order!",
            description:
              error.message ||
              "Something went wrong while updating the order status.",
          });
          setIsLoading(false);
        },
      })
    );
  };

  return (
    <>
      <Modal
        title={
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontSize: 18,
              fontWeight: 600,
            }}
          >
            {orderStatusValue === "receivedAtLab"
              ? "Labelling Form Completed Successfully"
              : "Labelling Form Updated Successfully"}
            <FaCheckCircle size={24} color="#2E7D32" />
          </span>
        }
        visible={open}
        centered
        onCancel={() => setOpen(false)}
        bodyStyle={{ borderRadius: 8, padding: 32, minHeight: 130 }}
        style={{ borderRadius: 8, overflow: "hidden", minWidth: 400 }}
        footer={[
          <Button
            key="goBack"
            type={orderStatusValue === "receivedAtLab" ? "default" : "primary"}
            onClick={() => history.goBack()}
            style={{ fontWeight: 500, fontSize: 16 }}
          >
            Go Back
          </Button>,
          orderStatusValue === "receivedAtLab" && (
            <Button
              key="confirm"
              type="primary"
              style={{ fontWeight: 500, fontSize: 16 }}
              onClick={handleOk}
              loading={isLoading}
            >
              Move to Under Testing
            </Button>
          ),
        ]}
      >
        <Text style={{ fontSize: 16, color: "#9b9ea4ff", fontWeight: 600 }}>
          {orderStatusValue === "receivedAtLab"
            ? "Labelling details have been saved successfully. Would you like to move this order to under testing or return back?"
            : "Labelling details have been updated successfully. Would you like to return back?"}
        </Text>
      </Modal>
    </>
  );
}

export default LabellingFormSuccessModal;
